module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f9f80a46c79989ec217b139a9faa11c7.png";